module.exports = __webpack_public_path__ + "static/media/034-kazakhstan.5fb9894b.svg";